__turbopack_context__.v({
  "listLink": "ListLink-module-scss-module__ixtIGG__listLink",
});
